"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _Constants = require("composer-plugins/plugins/questionAndAnswer/Constants");

function _default(objectType, object) {
  switch (objectType) {
    case _Constants.ObjectTypes.CONTACT:
      return object.get('vid');

    case _Constants.ObjectTypes.COMPANY:
      return object.get('companyId');

    case _Constants.ObjectTypes.DEAL:
      return object.get('dealId');

    case _Constants.ObjectTypes.TICKET:
      return object.get('ticketId');

    default:
      return null;
  }
}

module.exports = exports.default;